export const CoverageTypeEnums = {
  AMOUNT: 1,
  EVIDENCE: 2,
  EXCESS: 3
};